import { render } from "./transport-type-select.vue?vue&type=template&id=27cf9965&ts=true"
import script from "./transport-type-select.vue?vue&type=script&lang=ts"
export * from "./transport-type-select.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__